<template>
    <v-container fluid class="main-container responsive-height trading-details-page">
        <v-row dense>
            <v-col cols="12" xl="12">
                <LiveTradeTabs></LiveTradeTabs>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LiveTradeTabs from "@/components/PagesComponents/LiveTradePage/LiveTradeTabs.vue";
export default {
    components: {
        LiveTradeTabs,
    },
};
</script>

<style scoped>
.trading-details-page { padding: 18px 14px 28px; background: #f7f8fa; }
.theme--dark .trading-details-page { background: #030b13; }
@media (max-width: 600px) { .trading-details-page { padding: 12px 8px 20px; } }
</style>
